import z from "zod";

export const postCalculationReferencesSchema = z.object({
	referenceId: z.uuid(),
});

export type PostCalculationReferencesSchema = z.infer<typeof postCalculationReferencesSchema>;
